import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { toast } from 'react-toastify';

import VendorForm from 'components/purchase-order/vendor/VendorForm';

import { vendorApi } from 'api';
import paths from 'routes/paths';
import { useUserContext } from '../../../../providers/UserProvider';

const VendorCreate = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const { selectedTenant, selectedWarehouse } = useUserContext();

  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;

  const handleSubmit = async values => {
    try {
      setLoading(true);

      const response = await vendorApi.create(values);

      toast.success('Vendor created successfully.');

      navigate(paths.vendors.details(tenant, warehouse, response.id), {
        replace: true,
      });
    } catch (err) {
      toast.error('Failed to create vendor.');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate(paths.vendors.list(tenant, warehouse));
  };

  return (
    <Card>
      <Card.Header className="bg-light">
        <h5 className="mb-0">Create Vendor</h5>
      </Card.Header>

      <Card.Body>
        <VendorForm
          isLoading={loading}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
        />
      </Card.Body>
    </Card>
  );
};

export default VendorCreate;
